import "../common";

import "../components/hotel/ContentFeeder";
import "../components/hotel/FilterCheckbox";
import "../components/PictureGallery";
import "../components/hotel/Stage";
import "../components/travel-data/CalendarView";
import "../components/travel-data/GuestSelectorView";
import "../components/FAQEntry";
import { setZone as stroerSetZone } from "@escapio/portal/components/ads/stroer/Ads";
import "../components/ads/stroer/Banner";
import { load as loadOptimonk } from "../components/ads/optimonk/loader";
import "../components/hotel/SharingButton";
import "../components/hotel/GoogleRemarketingTracker";
import "../components/hotel/BookingReviewLink";
import "../components/FooterItemLinkNewsletter";
import "../components/tracker/ImpressionInteractionTracker";
import "../components/map/StaticHotelMap";
import "@escapio/portal/components/hotel/StageBadge";
import { track } from "../tracker/EventTracker";

loadOptimonk();

let mapDialog;
function showHotelMapDialog(event, origin) {
	event.preventDefault();
	event.stopPropagation();
	mapDialog = mapDialog || new ProfileMapDialog();
	mapDialog.show(origin);
}

document
	.querySelectorAll("#stage__heading-map, esc-static-hotel-map")
	.forEach(node =>
		node.addEventListener("click", event => showHotelMapDialog(event, "Bühne")),
	);

import "../components/HotelFavoriteStatus";
import { onChangeAny } from "../state/travelData";
import {
	store,
	ACTION_PARSE_HASH,
	ACTION_REQUEST_PRICES,
} from "../components/hotel/DataStore";
import "../components/hotel/PriceHeader";
import "../components/hotel/DirectLinkBox";
import "../components/hotel/DirectContactBox";
import "../components/hotel/PriceList";
import "../components/hotel/TravelDataToggle";
import { GalleryDialog } from "../components/hotel/GalleryDialog";

store.dispatch(ACTION_PARSE_HASH, location.hash);
onChangeAny(() => store.dispatch(ACTION_REQUEST_PRICES));

import { data } from "../../shared/state/payload";
const { hotel } = data;
import { add as addToHistory } from "../state/history";
import { trackPageVisit } from "@escapio/portal/tracker/Pinterest";
import { ProfileMapDialog } from "@escapio/portal/components/map/ProfileMapDialog.js";

addToHistory({
	item_id: hotel.id,
	name: hotel.name,
	label: hotel.name,
	link: hotel.path,
	type: data["page_search_type"],
	type_label: data["page_search_type_label"],
	geo_paths: [hotel.city_name, hotel.region_name, hotel.country_name].filter(
		item => item,
	),
	hotels_number: null,
	is_alternative: false,
});

stroerSetZone("hoteldetail");
trackPageVisit(hotel.id, hotel.name);

// @TODO move to some custom element?
// ********************** GALLERY **********************
let galleryDialog;
function getGalleryDialogOpener(origin, index) {
	return () => {
		galleryDialog = galleryDialog || new GalleryDialog(data.hotel, "Hotel");
		galleryDialog.show(index);
		track("Hotel", "Klick Bildergalerie", `${origin} - ${index + 1}`);
	};
}

// stage picture gallery (mobile)
const stagePictureGallery = document.querySelector(".stage__picture-gallery");
stagePictureGallery.addEventListener("click", () => {
	getGalleryDialogOpener("Bühne", stagePictureGallery.currentPicture)();
});

// stage pictures (desktop)
document.querySelectorAll(".stage__pictures .stage__picture").forEach(node => {
	const index = parseInt(node.getAttribute("data-gallery-index"));
	node.addEventListener("click", getGalleryDialogOpener("Bühne", index));
});

// preview pictures
document
	.querySelectorAll(".-profile__gallery-preview__wrapper")
	.forEach(node => {
		const index = parseInt(node.getAttribute("data-gallery-index"));
		node.addEventListener("click", getGalleryDialogOpener("Content", index));
	});
// ********************** GALLERY **********************
